import { ResourcesComponent } from "@/features";

export const ResourcesPage = () => {
  return <ResourcesComponent />;
}